import { MUSCLE_GROUP_IDS, MUSCLE_GROUP_NAMES, type MuscleGroup } from '@squats/shared';

/** Read-only muscle group chips. */
export function MuscleChips({ groups, muted = false }: { groups: readonly MuscleGroup[]; muted?: boolean }) {
  return (
    <span className="chips">
      {groups.map((g) => (
        <span key={g} className={muted ? 'chip muted' : 'chip'}>
          {MUSCLE_GROUP_NAMES[g]}
        </span>
      ))}
    </span>
  );
}

/** Toggle buttons for choosing muscle groups. */
export function MusclePicker({
  value,
  onChange,
  label,
  exclude = [],
}: {
  value: MuscleGroup[];
  onChange: (next: MuscleGroup[]) => void;
  label: string;
  exclude?: readonly MuscleGroup[];
}) {
  return (
    <fieldset className="field">
      <legend>{label}</legend>
      <div className="chips">
        {MUSCLE_GROUP_IDS.filter((g) => !exclude.includes(g)).map((g) => {
          const on = value.includes(g);
          return (
            <button
              key={g}
              type="button"
              className={on ? 'chip toggle on' : 'chip toggle'}
              aria-pressed={on}
              onClick={() => onChange(on ? value.filter((x) => x !== g) : [...value, g])}
            >
              {MUSCLE_GROUP_NAMES[g]}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
